import Banner from '../../container/CommitteeBanner'
import Ramkumar from '../../assets/speakers/Ramkumar-Ketti-ramachandran.png'
export default function PreConference() {
    return(
        <main>
            <Banner title={'Pre-conference Tutorial'} context={'The pre-conference tutorial sessions will be held on the first day of conference, designed to provide in-depth knowledge and hands-on training on specific topics related to the conference theme. These tutorials are conducted by experts to cater for the participants looking to enhance their skills and understanding on specific area related to the conference theme.'} />
            {/* Speaker Row */}
            <section className="px-4 sm:px-6 lg:px-10 py-8">
                <div className="flex flex-col md:flex-row items-start md:items-center gap-5 sm:gap-8 max-w-6xl mx-auto w-full">
                    {/* Photo */}
                    <div className="shrink-0 self-center md:self-start">
                        <img
                            src={Ramkumar}
                            alt="Dr. Ramkumar Ketti Ramachandran"
                            className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-40 lg:h-40 xl:w-44 xl:h-44 rounded object-cover border"
                        />
                    </div>

                    {/* Details */}
                    <div className="flex-1 w-full">
                        <div className="rounded-2xl border p-4 sm:p-5 lg:p-6 w-full">
                            <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold leading-snug">
                                Dr. Ramkumar Ketti Ramachandran
                            </h3>
                            <div className="mt-2 sm:mt-3 text-gray-700 leading-relaxed text-sm sm:text-base">
                                <p>Professor – Research</p>
                                <p>Computer Science and Engineering</p>
                                <p>Chitkara University Research and Innovation Network (CURIN)</p>
                                <p>Chitkara University, Punjab, INDIA.</p>
                            </div>
                        </div>

                        {/* Topic */}
                        <div className="mt-3 sm:mt-4 w-full">
                            <p className="font-semibold text-sm sm:text-base">
                                Topic:
                                <span className="font-normal ml-2 block sm:inline mt-1 sm:mt-0">
                                    Connected Intelligence: Powering the Future with AI, IoT & Cloud
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}